import React, {Component} from 'react';
import AppScreenShot from '../images/app-sc.png';
import './Appointments.css';
import {Redirect, Prompt} from 'react-router-dom';
import {Header} from './Appointments/Header';
import GridView from './GridView';
import CalendarView from './CalendarView';
import DateHelper from '../components/DateHelper';
import SideBar from './Appointments/SideBar';
import ClientView from './Clients/ClientView';
import DoctorView from './Clients/DoctorView';
import SettingsView from './SettingsView';
import NoShow from './NoShow';
import {SideModal} from '../components/BioPedModal';
import Print from './Print';
import FollowUpView from './followup/FollowUpView';
import ClinicService from '../api/services/ClinicService';
import AccountService from '../api/services/AccountService';
import AppointmentService from '../api/services/AppointmentService';
import AppointmentTypeService from '../api/services/AppointmentTypeService';
import AssessmentService from '../api/services/AssessmentService';
import Init from './Init';
import {LoadingSpinner} from '../components/BiopedUI';
import PendingView from "./pending/PendingView";
import ExtAppService from "../api/services/ExtAppService";
import AppPrintView from "./print/AppPrintView";

export default class Appointments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sideBarValue: '',
			actions: {calendarType: 'day'},
			isLoading: true,
			loadingText: 'Loading...',
			calendarIsBusy: false
		};
		this.account = new AccountService();
		this.appointments = new AppointmentService();
		this.clinic = new ClinicService();

		this.state.currentClinicId = this.account.clinicId;
		this.state.currentDoctorId = this.account.userId;
		this.state.date = new Date();

		this.handleClinicChange = this.handleClinicChange.bind(this);
		this.handleDoctorChange = this.handleDoctorChange.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleAppointmentLoad = this.handleAppointmentLoad.bind(this);
		this.updateAppointments = this.updateAppointments.bind(this);

		this.sideBarChange = this.sideBarChange.bind(this);
		this.handleOnAction = this.handleOnAction.bind(this);
		this.handleSectionHeader = this.handleSectionHeader.bind(this);
		/* let ps = new PatientService();
        ps.getAll();*/

		// this.sideBarChange(null, true);

		window.addEventListener('LoggedOut', (e) => {
			this.forceUpdate();
		})

	}

	handleLogout(e) {
		this.forceUpdate();
	}

	handleClinicChange(clinicId) {
		this.state.currentClinicId = clinicId;
		this.account.clinicId = clinicId;
		this.setState({isLoading: true});
		//this.updateAppointments();
	}

	handleDoctorChange(doctorId) {
		this.state.currentDoctorId = doctorId;
		this.updateAppointments();
	}

	handleDateChange(date) {
		this.state.date = date;
		console.log("handleDateChange:", date)
		this.updateAppointments();
	}

	updateAppointments() {
		let date = this.state.date;
		let dh = new DateHelper();
		const calRange = this.state.actions.calendarType === 'list' ? 'week' : this.state.actions.calendarType;
		let dateRange = DateHelper.GetRange(date, calRange); //dh.getWeekRange(date);
		console.log("updateAppointments Date Range:", dateRange);
		console.log('calendarType:', this.state.actions.calendarType)
		this.setState({calendarIsBusy: true});
		if (calRange === 'week') {
			this.appointments.getByDrId(this.state.currentDoctorId, dateRange[0], dateRange[1]).then(this.handleAppointmentLoad);
		} else {
			this.appointments.getByDates(dateRange[0], dateRange[1], this.state.currentClinicId).then(this.handleAppointmentLoad);
		}

	}

	handleAppointmentLoad(json) {
		console.log('Loaded Appointments:', json);
		this.account.clinicId = this.state.currentClinicId;
		this.setState({
			appData: json,
			isBusy: false,
			currentClinicId: this.state.currentClinicId,
			date: this.state.date,
			calendarIsBusy: false
		});
	}

	sideBarChange(v, unmounted) {
		this.setState({sideBarValue: v});
	}

	handleOnAction(action, value) {
		let a = Object.assign({}, this.state.actions || {});
		a[action] = value;
		console.log("Actions:", a)
		this.setState({actions: a});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		console.log("****** Appointment Did Update prevState:", prevState)
		if (prevState.actions.calendarType !== this.state.actions.calendarType) {
			this.updateAppointments();
		}
	}

	componentDidMount() {
		ExtAppService.AddListener('appointments-main', (bcApps) => {
			this.setState({bcApps})
		})
	}

	componentWillUnmount() {
		ExtAppService.RemoveListener('appointments-main');
	}

	handleSectionHeader(header) {
		if (this.headerRef) {
			this.headerRef.updateHeader(header);
		}
		//this.sectionHeader = header;
		//this.setState({sectionHeader:header})
	}

	getCurrentView() {
		let view = null;
		let dr = ClinicService.GetDrById();
		let calStart = dr.settings.getData('CalendarViewTimeStart');
		let calEnd = dr.settings.getData('CalendarViewTimeEnd');
		switch (this.state.sideBarValue) {
		case 'clients':
			view = <ClientView onSectionHeader={this.handleSectionHeader} clinicId={this.state.currentClinicId}/>;
			break;
		case 'settings':
			view = <SettingsView onSectionHeader={this.handleSectionHeader} clinicId={this.state.currentClinicId}/>;
			break;
		case 'dr':
			view = <DoctorView onSectionHeader={this.handleSectionHeader}/>;
			break;
		case 'followups':
			view = <FollowUpView onSectionHeader={this.handleSectionHeader} clinicId={this.state.currentClinicId}/>
			break;
		case 'pendingTab':
			view = <PendingView onSectionHeader={this.handleSectionHeader} bcApps={this.state.bcApps}/>
			break;
		default:
			view = <CalendarView cols="7" rows="8" date={this.state.date} appData={this.state.appData}
			                     onRequestReload={this.updateAppointments}
			                     clinicId={this.state.currentClinicId}
			                     doctorId={this.state.currentDoctorId}
			                     onRequestCloseLegend={() => this.setState({shelfLegend: 'closed'})}
			                     shelfLegend={this.state.shelfLegend}
			                     actions={this.state.actions || {}}
			                     onActionClick={this.handleOnAction}
			                     onSectionHeader={this.handleSectionHeader}
			                     onDateChange={this.handleDateChange}
			                     onDoctorChange={this.handleDoctorChange}
			                     startTime={calStart}
			                     endTime={calEnd}
			                     activeStartTime={calStart}
			                     activeEndTime={calEnd}
			                     isBusy={this.state.calendarIsBusy}
			                     bcApps={this.state.bcApps}
			/>;
			break
		}

		return view;
	}

	handleInitComplete = () => {
		this.setState({isLoading: false});
	}

	render() {
		if (!this.account.isLoggedIn) {
			return (<Redirect
				to={{
					pathname: '/',
					state: {
						from: "/appointments"
					}
				}}/>)
		}

		if (this.state.isLoading) {
			return (<Init onComplete={this.handleInitComplete} clinicId={this.state.currentClinicId}/>);
		}

		/*AssessmentService.GetAssessmentByPatientId(605551).then((json)=>{
			console.log("Assessments:", json);
		})*/
		console.log('Appointment Render Actions:', this.state.actions)
		return (
			<div>
				<Header account={this.account} clinicId={this.state.currentClinicId}
				        onClinicChange={this.handleClinicChange}
				        onDoctorChange={this.handleDoctorChange}
				        onDateChange={this.handleDateChange}
				        onActionClick={this.handleOnAction}
				        actions={this.state.actions || {}}
				        ref={(ref) => this.headerRef = ref}
				/>
				<div className="table hmax align-top">
					<div>
						<SideBar value={this.state.sideBarValue} onChange={this.sideBarChange}/>
						{this.getCurrentView()}
					</div>
				</div>

				<SideModal isOpen={this.state.actions.noShowVisible}
				           onRequestClose={() => this.handleOnAction('noShowVisible', false)}>
					<NoShow onRequestClose={() => this.handleOnAction('noShowVisible', false)}/>
				</SideModal>
				<SideModal isOpen={this.state.actions.printAppsVisible}
				           onRequestClose={() => this.handleOnAction('printAppsVisible', false)}>

					<AppPrintView onRequestClose={() => this.handleOnAction('printAppsVisible', false)} date={this.state.date} appData={this.state.appData} />
				</SideModal>
				<Prompt
					when={true}
					message={location =>
						`Are you sure you want to go to ${location.pathname}`
					}
				/>
				{(this.state.calendarIsBusy) ? <div class="App-Busy-Spinner"><LoadingSpinner/></div> : null}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/Appointments.jsx